export default "__VITE_ASSET__DrZJVVjW__"